import React from 'react';
import MasterAppointmentForm from '../MasterAppointmentForm';
import ServantAppointmentForm from '../ServantAppointmentForm';
import JurisdictionForm from '../JurisdictionForm';
import { AppointmentGroupState } from '../types';

/**
 * AppointmentGroupFormコンポーネント用のPropsです。
 * @interface AppoimentGroupFormProps
 */
interface AppoimentGroupFormProps {

  /**
   * 委任事項の索引
   * @type {number}
   * @memberof AppoimentGroupFormProps
   */
  appointmentIndex: number;

  /**
   * 委任事項グループ
   * @type {AppointmentGroup}
   * @memberof AppoimentGroupFormProps
   */
  appointmentGroup : AppointmentGroupState;

  /**
   * 委任事項（メイン）のチェック状態を更新する関数です。
   * @type {function}
   * @memberof AppoimentGroupFormProps
   */
  updateMasterAppointmentIsChecked: (appointmentIndex: number, isChecked: boolean) => void;

  /**
   * 委任事項（サブ）のチェック状態を更新する関数です。
   * @type {function}
   * @memberof AppoimentGroupFormProps
   */
  updateServantAppointmentIsChecked:  (appointmentIndex: number, servantAppointmentIndex: number, isChecked: boolean ) => void;

  /**
   * 法域のチェック状態を更新する関数です。
   * @type {function}
   * @memberof AppoimentGroupFormProps
   */
  updateJurisdictionIsChecked: (appointmentIndex: number, jurisdictionIndex: number, isChecked: boolean) => void;
}

/**
 * 委任事項グループフォームのコンポーネントです。
 * @param {number} props.appointmentIndex - 委任事項の索引
 * @param {AppointmentGroup} props.appointmentGroup - 委任事項グループ
 * @param {function} props.updateMasterAppointmentIsChecked - 委任事項（メイン）のチェック状態が変更されたときに呼ばれるコールバック関数
 * @param {function} props.updateServantAppointmentIsChecked - 委任事項（サブ）のチェック状態が変更されたときに呼ばれるコールバック関数
 * @param {function} props.updateJurisdictionIsChecked - 法域のチェック状態が変更されたときに呼ばれるコールバック関数
 * @returns {JSX.Element} - 委任事項グループフォームのJSX要素
 */
const AppointmentGroupForm: React.FC<AppoimentGroupFormProps> = (
  {
    appointmentIndex,
    appointmentGroup,
    updateMasterAppointmentIsChecked,
    updateServantAppointmentIsChecked,
    updateJurisdictionIsChecked
  }
) => {

  return (
    <>
      <MasterAppointmentForm
        key={appointmentIndex}
        index={appointmentIndex}
        appointment={appointmentGroup.masterAppointment}
        onChange={updateMasterAppointmentIsChecked}
      />
      {
        appointmentGroup.jurisdictions.map((jurisdcition, jurisdcitionIndex) => {
          return (
            <JurisdictionForm
              key={jurisdcitionIndex}
              appointmentIndex={appointmentIndex}
              appointmentId={appointmentGroup.masterAppointment.appointmentId}
              jurisdictionIndex={jurisdcitionIndex}
              jurisdiction={jurisdcition}
              onChange={updateJurisdictionIsChecked}
              disabled={appointmentGroup.jurisdictions.length <= 1 ? true : false}
            />
          );
        })
      }
      {
        appointmentGroup.servantAppointments.map((servantAppointment, servantAppointmentIndex) => {
          return (
            <ServantAppointmentForm
              key={servantAppointmentIndex}
              appointmentIndex={appointmentIndex}
              servantAppointmentIndex={servantAppointmentIndex}
              appointment={servantAppointment}
              onChange={updateServantAppointmentIsChecked}
              // disabled={appointmentGroup.servantAppointments.length >= 1 ? true : false}
            />
          );
        })
      }
    </>
  );
}

export default AppointmentGroupForm;